interface ToastListener {
  onShow(message: string): void
  onHide(): void
}

export class ToastManager {
  visible = false
  #Listener: ToastListener | undefined
  show(message: string) {
    this.visible = true
    this.#Listener?.onShow(message)
  }

  hide() {
    this.visible = false
    this.#Listener?.onHide()
  }

  setListener(listener: ToastListener) {
    this.#Listener = listener
  }
}

const INSTANCE = new ToastManager()

export { INSTANCE }
